import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ExpedicionesContextService } from "../../../context/expediciones-context.service";
import { SpinnerService } from "shared-components";
import { ExpedicionesService } from "../../../services/expediciones.service";

@Component({
  selector: "app-expedicion-certificado",
  templateUrl: "./expedicion-certificado.component.html",
})
export class ExpedicionCertificadoComponent implements OnInit {
  public expediciones;
  private _filters;

  // Paginación
  public itemsPerPage = 10;
  public currentPage = 0;
  public totalItems: number;
  public readonly visiblePages = 3;

  // Ordenación
  public orderBy: string;
  public columnId: string;

  @Input() certificadoId: number;

  constructor(
    private _translate: TranslateService,
    private _spinnerService: SpinnerService,
    private _certificadosService: ExpedicionesService,
  ) {}

  ngOnInit(): void {
    this.getExpedicionesCertificado();
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public getExpedicionesCertificado() {
    if (this._filters) {
      this._filters = this._filters;

      this._spinnerService.showSpinner();
      this._certificadosService
        .getExpedicionesConfeccionesDetail(this._filters)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then((resp) => {
          this.expediciones = resp.lista;
          this.totalItems = resp.paginacionMeta.totalCount;
        });
    } else {
      this.applyFilters();
    }
  }

  private applyFilters() {
    this.currentPage = 0;
    this._filters = {
      certificadoExpedicionId: this.certificadoId ? this.certificadoId : 0,
      numPagina: this.currentPage,
      tamPagina: this.itemsPerPage,
    };
    this.getExpedicionesCertificado();
  }

  public pageChange(page) {
    this._filters.numPagina = this.currentPage = page - 1;
    this.getExpedicionesCertificado();
  }

  public itemsPerPageChange(items) {
    this._filters.numPagina = this.currentPage = 0;
    this._filters.tamPagina = this.itemsPerPage = items;
    this.getExpedicionesCertificado();
  }

  public toOrderBy(columnFilter: string, colId: string) {
    this.columnId = colId;

    if (this.expediciones && this.expediciones.length > 0 && this._filters) {
      const isAscending = !this.orderBy || this.orderBy.includes("DESC");
      this.orderBy = isAscending ? "ASC" + colId : "DESC" + colId;
      this._filters.orderItems = [
        {
          orderProperty: columnFilter,
          orderByDescending: !isAscending,
        },
      ];

      this._spinnerService.showSpinner();
      this._certificadosService
        .getExpedicionesConfeccionesDetail(this._filters)
        .toPromise()
        .finally(() => {
          this._spinnerService.hideSpinner();
        })
        .then((resp) => {
          this.expediciones = resp.lista;
          this.totalItems = resp.paginacionMeta.totalCount;
        });
    }
  }

  public getIcon(prop: string, colId: string) {
    let iconClass = "fa fa-sort";
    if (
      this._filters &&
      this._filters.orderItems &&
      this._filters.orderItems[0].orderProperty.indexOf(prop) != -1 &&
      this.columnId === colId
    ) {
      iconClass =
        this._filters.orderItems[0].orderByDescending === true
          ? "fa fa-sort-down"
          : "fa fa-sort-up";
    }
    return iconClass;
  }
}
